module.exports = __webpack_public_path__ + "img/27.42a6607a.jpg";